/**
 * Single-step undo for the Media Creator editor: one snapshot of the layout before the latest user change.
 * Repeated events from the same source (one drag, one typing burst) coalesce so undo reverts the whole gesture.
 */

export const UNDO_COALESCE_MS = 800;

export const EMPTY_UNDO = Object.freeze({ snapshot: null, source: null, at: 0 });

/**
 * @param {{ snapshot: object|null, source: string|null, at: number }} state
 * @param {object} prevLayout layout before this change
 * @param {string} source e.g. `layout:headline`, `html`, `css:headline`, `ai`
 * @param {number} [now]
 */
export function recordUndo(state, prevLayout, source, now = Date.now()) {
  if (!source || !prevLayout) return state || EMPTY_UNDO;
  const current = state || EMPTY_UNDO;
  if (current.snapshot && current.source === source && now - current.at < UNDO_COALESCE_MS) {
    return { ...current, at: now };
  }
  return { snapshot: prevLayout, source, at: now };
}

/** Do not hijack Ctrl+Z while the user is typing in a field (browser undo handles that). */
export function isTypingTarget(el) {
  if (!el || typeof el !== 'object') return false;
  const tag = el.tagName?.toLowerCase?.();
  if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
  return Boolean(el.isContentEditable || el.getAttribute?.('contenteditable') === 'true');
}
